<template>
  <section id="lunbo">
    <!--顶部查询条件-->
    <Form :model="tqtShuffling" inline>
      <FormItem>
        <Input v-model="tqtShuffling.title" placeholder="标题" clearable></Input>
      </FormItem>
      <!--查询按钮-->
      <FormItem>
        <Button icon="ios-search" shape="circle" @click="search">查询</Button>
      </FormItem>

      <!--新建按钮-->
      <FormItem>
        <Button type="primary" icon="md-add" shape="circle" @click="modal1 = true; $refs.form.resetFields()">新增
        </Button>
      </FormItem>
    </Form>
    <Table border :columns="columns" :data="tableData" :loading='loading'></Table>
    <div class="page-area">
      <Page :total="pageTotal" :current="pageOffset" :page-size="pageLength" @on-change="handlePageChange" show-total
        show-elevator />
    </div>
    <div>
      <CModal v-model="modal1" title="新增" @on-ok="ok" :okLoading="okLoading2">
        <Form ref="form" :rules="rules" :model="formLeft" label-position="left" :label-width="100">
          <FormItem label="标题">
            <Input v-model="formLeft.input1"></Input>
          </FormItem>

          <FormItem label="照片" prop="pic">
            <upload :action="uploadUrl" :headers="headers" :limit="1" :file-list="picList" list-type="picture-card"
              :before-upload="beforeAvatarUpload" :on-success="handleSuccess" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </upload>
            <span style="font-size:10px ; color: red">建议图片680*290</span>
          </FormItem>
          <FormItem label="所属页面" prop="type" v-model="formLeft.type">
            <Select v-model="formLeft.type">
              <Option :value="1">首页</Option>
              <Option :value="2">政策专家库</Option>
              <Option :value="3">泰链圈</Option>
            </Select>
          </FormItem>
          <FormItem label="是否上架" prop="input4" v-model="formLeft.input4">
            <RadioGroup v-model="formLeft.input4">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="排序" prop="input3">
            <Select v-model="formLeft.input3">
              <Option value="1">第一页</Option>
              <Option value="2">第二页</Option>
              <Option value="3">第三页</Option>
              <Option value="4">第四页</Option>
              <Option value="5">第五页</Option>
            </Select>
          </FormItem>
        </Form>
      </CModal>
    </div>
    <!--
        编辑轮播
     -->
    <div>
      <CModal v-model="modal2" title="编辑" @on-ok="ok2" :okLoading="okLoading">
        <Form ref="form2" :rules="rules" :model="formLeft2" label-position="left" :label-width="100">
          <FormItem label="标题">
            <Input v-model="formLeft2.input1"></Input>
          </FormItem>

          <FormItem label="图片" prop="pic">
            <upload :action="uploadUrl" :headers="headers" :limit="1" list-type="picture-card" :file-list="fileList"
              :before-upload="beforeAvatarUpload" :on-success="handleSuccess" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </upload>
            <span style="font-size:10px ; color: red">建议图片680*290</span>
          </FormItem>
          <FormItem label="所属页面" prop="type" v-model="formLeft2.type">
            <Select v-model="formLeft2.type">
              <Option :value="1">首页</Option>
              <Option :value="2">政策专家库</Option>
              <Option :value="3">泰链圈</Option>
            </Select>
          </FormItem>
          <FormItem label="是否上架" prop="input4">
            <RadioGroup v-model="formLeft2.input4">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="排序" prop="input3">
            <Select v-model="formLeft2.input3">
              <Option value="1">第一页</Option>
              <Option value="2">第二页</Option>
              <Option value="3">第三页</Option>
              <Option value="4">第四页</Option>
              <Option value="5">第五页</Option>
            </Select>
          </FormItem>
        </Form>
      </CModal>
    </div>
  </section>
</template>
<script>
import util from '@/libs/util.js'
import upload from '@/components/upload'
import CModal from '@/components/cModel'

export default {
  components: { upload, CModal },
  name: 'tqtShufflingList',
  data() {
    return {
      loading: false,
      rules: {
        pic: [{ required: true, message: '请上传图片', trigger: 'change' }],
        input4: [{ required: true, message: '请选择是否上架', trigger: 'change' }],
        input3: [{ required: true, message: '请选择排序', trigger: 'change' }],
      },
      okLoading2: false,
      okLoading: false,
      picList: [],
      tupiandizhi: '',
      fileList: [
        {
          name: '',
          url: '',
        },
      ],
      headers: {
        Authorization: localStorage.token,
      },
      uploadUrl: util.baseUrl + 'api/common/upload',
      formLeft: {
        pic: null,
        input1: '',
        input3: '',
        input4: '',

      },
      formLeft2: {
        pic: null,
        input1: '',
        input3: '',
        input4: '',
        type: ''
      },
      modal1: false,
      modal2: false,
      //分页参数
      pageLength: 10, // 每页条数
      pageTotal: 0, //总数
      pageOffset: 1, //页码
      //查询参数
      tqtShuffling: {
        title: '',
      },
      columns: [
        {
          key: 'xuhao',
          title: '序号',
          width: 70,
          align: 'center'
        },
        {
          key: 'title',
          title: '标题',
          align: 'center'
        },
        {
          key: 'type',
          title: '所属页面',
          align: 'center',
          render: (h, params) => {
            let nameMap = {
              1: '首页',
              2: '政策专家库',
              3: '泰链圈'
            }
            let name = nameMap[params.row.type]
            return h('span', name)
          },
        },

        {
          key: 'pic',
          title: '照片',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('div', [
              h('Img', {
                style: { marginTop: '5px' },
                attrs: {
                  src: params.row.pic || '',
                  width: '100%',
                  height: '100%',
                },
              }),
            ])
          },
        },
        {
          key: 'createTime',
          title: '发布时间',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'span',
                {
                  domProps: {
                    innerHTML: this.formatTime(params.row.createTime)
                  },
                },
              ),
            ])
          }
        },

        {
          title: '操作',
          align: 'center',
          width: 280,
          key: 'id',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.xiangqing(params.row.id)
                    },
                  },
                },
                '编辑'
              ),
              params.row.status == 1
                ? h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small',
                    },
                    style: {
                      marginLeft: '15px',
                    },
                    on: {
                      click: () => {
                        this.edit(params.row.id, params.row.status, params.row)
                      },
                    },
                  },
                  '下架'
                )
                : h(
                  'Button',
                  {
                    props: {
                      type: 'primary',
                      size: 'small',
                    },
                    style: {
                      marginLeft: '15px',
                    },
                    on: {
                      click: () => {
                        this.edit(params.row.id, params.row.status, params.row)
                      },
                    },
                  },
                  '上架'
                ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginLeft: '15px',
                  },
                  on: {
                    click: () => {
                      this.delete(params.row.id)
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ],
      tableData: [],
    }
  },
  mounted() {
    this.listTable()
  },
  methods: {
    onCancel() {
      this.formLeft2 = {
        pic: null,
        input1: '',
        input3: '',
        input4: '',
        type: ''
      }
      this.formLeft = {
        pic: null,
        input1: '',
        input3: '',
        input4: '',
        type: ''
      }
      this.picList = []
    },
    //新增
    ok() {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          this.$Message.warning('请检查填写的信息');
          return
        }
        this.okLoading2 = true;
        util.http
          .post('/api/tqtShufflings', {
            lunboSource: _this.formLeft.pic,
            sort: _this.formLeft.input3,
            status: _this.formLeft.input4,
            title: _this.formLeft.input1,
            type: _this.formLeft.type
          })
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              _this.$Notice.success({
                title: '新增成功',
              })
              _this.onCancel();
              _this.modal1 = false;
              _this.listTable()
            } else {
              _this.$Notice.error({
                title: '新增失败',
              })
            }
          }).finally(() => {
            _this.okLoading2 = false;
          })
      })
    },
    handleSuccess(response, file, fileList) {
      if (response.success) {
        this.formLeft.pic = this.formLeft2.pic = response.result.path || ''
        this.picList = fileList
        // console.log()
      }
    },
    handleRemove(file, fileList) {
      this.formLeft.pic = this.formLeft2.pic = ''
      console.log(file, fileList)
    },
    //验证是否为图片
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    formatTime(UTCDateString) {
      if (!UTCDateString) {
        return '-'
      }

      function formatFunc(str) {
        //格式化显示
        return str > 9 ? str : '0' + str
      }

      var date2 = new Date(UTCDateString) //这步是关键
      var year = date2.getFullYear()
      var mon = formatFunc(date2.getMonth() + 1)
      var day = formatFunc(date2.getDate())
      var hour = date2.getHours()
      var min = formatFunc(date2.getMinutes())
      var second = date2.getSeconds()
      var dateStr =
        year + '-' + mon + '-' + day
      return dateStr
    },
    //渲染表格数据
    listTable() {
      let _this = this
      _this.loading = true
      const token = localStorage.token
      util.ajax
        .get('/api/tqtShufflingsByCriteria', {
          headers: {
            Authorization: token,
          },
          params: {
            title: _this.tqtShuffling.title,
          },
        })
        .then(function (response) {
          _this.tableData = []
          let data = response.data
          _this.pageTotal = data.recordsTotal
          let list = data.data
          for (let i = 0; i < list.length; i++) {
            let map = {
              xuhao: i + 1,
              id: list[i].id,
              pic: list[i].pic.url,
              title: list[i].title,
              createTime: list[i].createTime,
              status: list[i].status,
              type: list[i].type
            }
            _this.tableData.push(map)
          }
          _this.loading = false
        })
        .catch(function (error) {
          console.log(error)
          _this.loading = false
        })
    },
    //新建
    create() {
      this.$router.push({
        name: 'tqt_shuffling_item',
      })
    },
    //详情
    xiangqing(id) {
      let _this = this
      _this.fileList = [
        {
          name: '',
          url: '',
        },
      ]
      _this.modal2 = true
      util.http
        .get('/api/tqtShufflings/' + id, {
          params: {
            id: id,
          },
        })
        .then(function (response) {
          let tem = response.data
          _this.formLeft2.input1 = tem.title
          _this.formLeft2.input4 = tem.status + '';
          _this.formLeft2.input3 = tem.sort + '';
          _this.formLeft2.pic = tem.pic.uri
          _this.formLeft2.type = tem.type
          _this.fileList[0].url = tem.pic.url
          _this.tupiandizhi = tem.lunboSource
          _this.tupianid = tem.id
        })
        .catch(function (error) {
          _this.$Notice.error({
            title: '获取表单失败!',
          })
          console.log(error)
        })
    },
    //编辑
    ok2() {
      let _this = this
      this.$refs['form2'].validate((valid) => {
        if (!valid) {
          this.$Message.warning('请检查填写的信息');
          return
        }
        this.okLoading = true;
        util.http
          .put('/api/tqtShufflings', {
            lunboSource: _this.formLeft2.pic,
            sort: _this.formLeft2.input3,
            status: _this.formLeft2.input4,
            title: _this.formLeft2.input1,
            type: _this.formLeft2.type,
            id: _this.tupianid,
          })
          .then(function (response) {
            _this.$Notice.success({
              title: '更新成功!',
            })
            _this.modal2 = false;
            _this.listTable()
          }).finally(() => {
            _this.okLoading = false;
          })
      })
    },
    //上架
    edit(id, status, row) {
      let _this = this
      util.http
        .put('/api/updateTqtShufflingStatus', {
          status: status == 0 ? '1' : '0',
          id: id,
          type: row.type
        })
        .then(function (response) {
          if (response.status === 200) {
            _this.$Notice.success({
              title: '操作成功!',
            })
            _this.listTable()
          } else {
            _this.$Notice.error({
              title: response.title || '操作失败',
            })
          }
        })
        .catch(function (error) {
        })
    },

    //删除
    delete(id) {
      const token = localStorage.token
      let _this = this
      this.$Modal.confirm({
        title: '确定删除？',
        onOk() {
          util.ajax
            .delete('/api/tqtShufflings/' + id, {
              headers: {
                Authorization: token,
              },
            })
            .then((response) => {
              if (response.status === 200) {
                _this.$Notice.success({
                  title: '删除成功',
                })
                _this.listTable()
              } else {
                _this.$Notice.error({
                  title: '删除失败',
                })
              }
            })
        },
      })
    },
    //查询
    search() {
      this.pageOffset = 1
      this.listTable()
    },
    handlePageChange(current) {
      this.pageOffset = current
      this.listTable()
    },
  },
}
</script>
<style lang="less">
#lunbo {
  .el-upload-list__item {
    transition: none !important;
  }

  .query-model {
    width: 170px;
  }

  .page-area {
    display: flex;
    justify-content: flex-end;
    padding-top: 35px;
    padding-right: 50px;
  }
}
</style>
